var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelectBox',{attrs:{"className":_vm.className,"id":_vm.id,"value":_vm.theValue,"options":_vm.CCWithCCNameOptions,"title":_vm.$t('selectCountryCode'),"imgName":'earth.svg'},on:{"changeValue":function($event){_vm.theValue = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }